var hosecalc_map;
var hosecalc_points = [];
var hosecalc_arr_points = [];
var hosecalc_pointsLastState = [];
var hosecalc_polyline;
var hosecalc_arr_polylines = [];
var hosecalc_infoBubble;
var hosecalc_arr_infoBubbles = [];
var hosecalc_searchBox;
var hosecalc_boolPageHasControlsAdded = false;
var hosecalc_geocoder;

function initMap() {
  if (hosecalc_setting_boolDebugMode) console.log("Call:initMap");

  //setup the map
  hosecalc_map = new google.maps.Map(document.getElementById("hosecalc_map"), {
    center: { lat: 38, lng: -103.56 },
    zoom: 4,
    draggableCursor: "crosshair",
    streetViewControl: false,
    hosecalc_mapTypeControl: false,
    fullscreenControl: true,
    mapTypeControl: false,
    mapTypeId: hosecalc_setting_maptype,
    tilt: 0,
    fullscreenControl: hosecalc_setting_showFullScreenButton,
    zoomControlOptions: {
      position: google.maps.ControlPosition.TOP_RIGHT,
    },
  });

  //map click event
  google.maps.event.addListener(hosecalc_map, "click", mapclick);

  bounds = new google.maps.LatLngBounds();
  geocoder = new google.maps.Geocoder();

  //polyline
  hosecalc_polyline = new google.maps.Polyline({
    strokeColor: hosecalc_setting_lineColor,
    strokeOpacity: 1,
    strokeWeight: hosecalc_setting_lineWeight,
    geodesic: true,
    editable: true,
    clickable: false,
  });
  hosecalc_polyline.setMap(hosecalc_map);

  hosecalc_arr_polylines.push(hosecalc_polyline);

  initAutocomplete();

  //This is added once and not altered after
  var input_custombuttons = document.getElementById("custombuttons");
  hosecalc_map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
    input_custombuttons
  );

  //ftnCheckResponsive();

  if (hosecalc_setting_boolDebugMode)
    console.log(localStorage.getItem("address"));
  document.getElementById("pac-input").value = localStorage.getItem("address");

  var iDiv = document.createElement("div");
  iDiv.id = "imgdiv";

  iDiv.innerHTML =
    "<img src='https://cdn.shopify.com/s/files/1/0057/6451/3874/files/hc_bg.jpg?v=1744695485' style='height: 100%; width: 100%; object-fit: cover;overflow: hidden;'>";
  iDiv.style.zIndex = "1000";
  iDiv.style.width = "100%";
  iDiv.style.height = "100%";

  document.getElementById("hosecalc_map").childNodes[0].appendChild(iDiv);

  google.maps.event.addListenerOnce(hosecalc_map, "idle", function () {
    //loaded fully. hide the main hosecalc_map
    document.getElementsByClassName(
      "gm-style"
    )[0].childNodes[0].style.visibility = "hidden";
  });

  document.getElementById("totaldistance").style.backgroundColor =
    hosecalc_setting_ftmeasurementareabgcolor;

  document.getElementById("MTStd").style.backgroundColor = "#FFFFFF";
  document.getElementById("MTStd").style.color = "#8BAD3C";

  //distance calc prototypes
  google.maps.LatLng.prototype.kmTo = function (a) {
    var e = Math,
      ra = e.PI / 180;
    var b = this.lat() * ra,
      c = a.lat() * ra,
      d = b - c;
    var g = this.lng() * ra - a.lng() * ra;
    var f =
      2 *
      e.asin(
        e.sqrt(
          e.pow(e.sin(d / 2), 2) + e.cos(b) * e.cos(c) * e.pow(e.sin(g / 2), 2)
        )
      );
    return f * 6378.137;
  };

  google.maps.Polyline.prototype.inKm = function (n) {
    var a = this.getPath(n),
      len = a.getLength(),
      dist = 0;
    for (var i = 0; i < len - 1; i++) {
      dist += a.getAt(i).kmTo(a.getAt(i + 1));
    }
    return dist;
  };

  ftnCheckResponsive();
}

window.onresize = function (event) {
  ftnCheckResponsive();
};

window.onorientationchange = function () {
  ftnCheckResponsive();
};

function ftnCheckResponsive() {
  if (hosecalc_setting_boolDebugMode) console.log("Call:ftnCheckResponsive");
  if (hosecalc_setting_boolDebugMode)
    console.log(
      "boolPageHasControlsAdded=" + hosecalc_boolPageHasControlsAdded
    );

  if (hosecalc_map) {
    var input_customcontrol = document.getElementById("customcontrol");

    if (
      document.documentElement.clientWidth > 750 &&
      document.documentElement.clientHeight > 450
    ) {
      if (!hosecalc_boolPageHasControlsAdded) {
        hosecalc_map.controls[google.maps.ControlPosition.TOP_LEFT].push(
          input_customcontrol
        );
        hosecalc_boolPageHasControlsAdded = true;
      }
    } else {
      if (hosecalc_boolPageHasControlsAdded) {
        if (hosecalc_setting_boolDebugMode)
          console.log("boolPageHasControlsAdded POP");
        var newdiv =
          hosecalc_map.controls[google.maps.ControlPosition.TOP_LEFT].pop();
        document
          .getElementById("demoholder")
          .insertBefore(newdiv, document.getElementById("hosecalc_map"));
        newdiv.style.position = "relative";
        hosecalc_boolPageHasControlsAdded = false;
      }
    }
  }
}

function mapclick(event) {
  if (hosecalc_setting_boolDebugMode) console.log("Call:mapclick");

  //Undo is always visible after a hosecalc_map click
  document.getElementById("btn_undo").style.visibility = "visible";
  document.getElementById("btn_undo").disabled = false;
  document.getElementById("btn_undo").style.backgroundColor = "#8BAD3C";

  document.getElementById("btn_newhose").style.visibility = "visible";
  document.getElementById("btn_newhose").disabled = false;
  document.getElementById("btn_newhose").style.backgroundColor = "#8BAD3C";

  hosecalc_pointsLastState.push(clone(hosecalc_points)); //Need to clone it instead of copying the referance
  hosecalc_points.push(event.latLng);

  if (hosecalc_points.length == 1) {
    //https://github.com/googlemaps/js-info-bubble
    hosecalc_infoBubble = new InfoBubble({
      position: hosecalc_points[hosecalc_points.length - 1],
      backgroundColor: hosecalc_setting_calloutcolor,
      disableAutoPan: true,
    });

    attachEventListner(hosecalc_infoBubble, hosecalc_arr_polylines.length - 1);

    hosecalc_arr_infoBubbles.push(hosecalc_infoBubble);
  }

  ftn_refreshDisplay();
}

function clearmap() {
  //Start off with no path
  if (hosecalc_polyline) {
    hosecalc_polyline.setPath([]);
  }
}

function ftn_refreshDisplay() {
  if (hosecalc_setting_boolDebugMode) console.log("Call:ftn_refreshDisplay");

  if (hosecalc_points) {
    clearmap();

    if (hosecalc_points.length > 0) {
      hosecalc_polyline.setPath(hosecalc_points);
      var hosecalc_path = hosecalc_polyline.getPath();

      google.maps.event.addListener(
        hosecalc_polyline,
        "rightclick",
        deletepolypoint
      );
      google.maps.event.addListener(
        hosecalc_polyline,
        "click",
        clickonpolyline
      );
      google.maps.event.addListener(hosecalc_path, "set_at", set_at);
      google.maps.event.addListener(hosecalc_path, "remove_at", set_at);
      google.maps.event.addListener(hosecalc_path, "insert_at", set_at);
    }

    if (hosecalc_points.length == 1) {
      if (hosecalc_infoBubble) {
        hosecalc_infoBubble.close();
      }
    }

    if (hosecalc_points.length > 1) {
      hosecalc_infoBubble.setPosition(
        hosecalc_points[hosecalc_points.length - 1]
      );

      if (hosecalc_polyline) {
        var lengthInMeters = google.maps.geometry.spherical.computeLength(
          hosecalc_polyline.getPath()
        );
        lengthInMeters = lengthInMeters * 3.28084;
        var feetText =
          numberWithCommas(
            lengthInMeters.toFixed(hosecalc_setting_NumberofDecimalPlaces)
          ) + " ft.";
      }

      var content =
        '<div style="color:#FFFFFF;font-weight: bold;font-size: 13px;"><center>' +
        feetText +
        "<center></div>";

      hosecalc_infoBubble.setContent(content);
      hosecalc_infoBubble.open(hosecalc_map);
    }

    ftn_calctotdistance();
  }
}

function clickonpolyline(event) {
  if (hosecalc_setting_boolDebugMode) console.log("Call:clickonpolyline");
  //to prevent errors.
  google.maps.event.clearListeners(hosecalc_polyline, "click");
  mapclick(event);
}

function attachEventListner(infoBubble, index) {
  google.maps.event.addListener(infoBubble, "closeclick", function () {
    if (hosecalc_setting_boolDebugMode)
      console.log("Event:closeclick Index=" + index);

    hosecalc_arr_polylines[index].setMap(null);

    //reset current polyline
    hosecalc_arr_polylines[index].setPath([]);

    //if the polyline that is being closed is the current one...
    if (index == hosecalc_arr_polylines.length - 1) {
      hosecalc_points = [];
      hosecalc_polyline.setPath([]);
      hosecalc_polyline.setMap(hosecalc_map);
    }

    //if there are no areas left...
    var bool_checkvis = false;
    for (var i = 0, len = hosecalc_arr_polylines.length; i < len; i++) {
      if (hosecalc_arr_polylines[i].map) {
        //is visible
        bool_checkvis = true;
      }
    }

    ftn_calctotdistance();

    if (!bool_checkvis) {
      if (hosecalc_setting_boolDebugMode) console.log("NONE Left!");

      hosecalc_points = [];
      hosecalc_polyline.setPath([]);
      hosecalc_polyline.setMap(hosecalc_map);

      document.getElementById("totaldistance").style.visibility = "hidden";
      document.getElementById("totaldistance").innerHTML = "";
    }
  });
}

function ftn_calctotdistance() {
  //Calcalate total
  var totaldistance = 0;
  for (var i = 0, len = hosecalc_arr_polylines.length; i < len; i++) {
    if (hosecalc_arr_polylines[i]) {
      //is visible
      var lengthInMeters = google.maps.geometry.spherical.computeLength(
        hosecalc_arr_polylines[i].getPath()
      );
      lengthInMeters = lengthInMeters * 3.28084;
      var feet = lengthInMeters.toFixed(hosecalc_setting_NumberofDecimalPlaces);
      totaldistance += Number(feet);
    }
  }

  if (totaldistance > 0) {
    document.getElementById("totaldistance").style.visibility = "visible";
    var totfeetText =
      numberWithCommas(
        totaldistance.toFixed(hosecalc_setting_NumberofDecimalPlaces)
      ) + " ft.";

    if (
      document.documentElement.clientWidth > 550 &&
      document.documentElement.clientHeight > 450
    ) {
      document.getElementById("totaldistance").innerHTML =
        "Total Distance : " + totfeetText;
    } else {
      document.getElementById("totaldistance").innerHTML =
        "Total: " + totfeetText;
    }
  } else {
    document.getElementById("totaldistance").style.visibility = "hidden";
  }
}

function deletepolypoint(event) {
  if (hosecalc_setting_boolDebugMode) console.log("Call:deletepolypoint");

  google.maps.event.clearListeners(hosecalc_polyline, "rightclick");

  hosecalc_pointsLastState.push(clone(hosecalc_points)); //Need to clone it instead of copying the referance
  hosecalc_points.splice(event.vertex, 1);

  hosecalc_infoBubble.setPosition(hosecalc_points[hosecalc_points.length - 1]);
  ftn_refreshDisplay();

  google.maps.event.addListener(
    hosecalc_polyline,
    "rightclick",
    deletepolypoint
  );
}

function set_at() {
  if (hosecalc_setting_boolDebugMode) console.log("Call:set_at");

  hosecalc_pointsLastState.push(clone(hosecalc_points)); //Need to clone it instead of copying the referance
  hosecalc_points = hosecalc_polyline.getPath().getArray();

  hosecalc_infoBubble.setPosition(hosecalc_points[hosecalc_points.length - 1]);

  ftn_refreshDisplay();
}

function undo() {
  if (hosecalc_setting_boolDebugMode) console.log("Call:undo");

  if (hosecalc_points) {
    if (hosecalc_pointsLastState.length > 0) {
      hosecalc_polyline.setMap(null); //Required to avoid polyline issue where the old line remains
      hosecalc_points = hosecalc_pointsLastState.pop();
      hosecalc_polyline.setMap(hosecalc_map); //Required to avoid polyline issue where the old line remains
    } else {
      hosecalc_points = [];
    }
  }

  if (hosecalc_points.length == 0) {
    document.getElementById("btn_undo").disabled = true;
    document.getElementById("btn_undo").style.backgroundColor = "#d3d3d3";

    document.getElementById("btn_newhose").disabled = true;
    document.getElementById("btn_newhose").style.backgroundColor = "#d3d3d3";
  }

  ftn_refreshDisplay();
}

function initAutocomplete() {
  if (hosecalc_setting_boolDebugMode) console.log("Call:initAutocomplete");
  // Create the search box and link it to the UI element.
  var input = document.getElementById("pac-input");
  searchBox = new google.maps.places.SearchBox(input);
  //map.controls[google.maps.ControlPosition.TOP_RIGHT].push(input);

  // Bias the SearchBox results towards current hosecalc_map's viewport.
  hosecalc_map.addListener("bounds_changed", function () {
    searchBox.setBounds(hosecalc_map.getBounds());
  });

  var markers = [];

  // Listen for the event fired when the user selects a prediction and retrieve
  // more details for that place.
  searchBox.addListener("places_changed", function () {
    document.getElementsByClassName(
      "gm-style"
    )[0].childNodes[0].style.visibility = "visible";
    //hide the static image as it makes zooming/panning a poor experiance
    document.getElementById("imgdiv").style.visibility = "hidden";

    var places = searchBox.getPlaces();

    localStorage.setItem("address", document.getElementById("pac-input").value);

    if (places.length == 0) {
      document.getElementById("gobtn").style.backgroundColor = "red";
      return;
    }

    // Clear out the old markers.
    markers.forEach(function (marker) {
      marker.setMap(null);
    });
    markers = [];

    // For each place, get the icon, name and location.
    var bounds = new google.maps.LatLngBounds();
    //console.log(places);
    places.forEach(function (place) {
      if (!place.geometry) {
        console.log("Returned place contains no geometry");
        geocodeAddress(document.getElementById("pac-input").value);
        return;
      }
      document.getElementById("gobtn").style.backgroundColor = "#8BAD3C";

      var icon = {
        url: place.icon,
        size: new google.maps.Size(71, 71),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(17, 34),
        scaledSize: new google.maps.Size(25, 25),
      };

      // Create a marker for each place.
      markers.push(
        new google.maps.Marker({
          map: hosecalc_map,
          icon: icon,
          title: place.name,
          position: place.geometry.location,
        })
      );

      /*
		if (place.geometry.viewport) {
		  // Only geocodes have viewport.
		  bounds.union(place.geometry.viewport);
		} else {
		  bounds.extend(place.geometry.location);
		}
		hosecalc_map.fitBounds(bounds);
		*/

      hosecalc_map.setCenter(place.geometry.location);
      hosecalc_map.setZoom(hosecalc_setting_zoomtoaddress);
    });
  });
}

function ftn_goclick() {
  document.getElementsByClassName(
    "gm-style"
  )[0].childNodes[0].style.visibility = "visible";

  //hide the static image as it makes zooming/panning a poor experiance
  document.getElementById("imgdiv").style.visibility = "hidden";

  var input = document.getElementById("pac-input");
  google.maps.event.trigger(input, "focus");
  google.maps.event.trigger(input, "keydown", {
    keyCode: 13,
  });
}

function ftn_mtChange(mapTypeId) {
  if (hosecalc_setting_boolDebugMode) console.log("Call:ftn_mtChange");
  hosecalc_map.setMapTypeId(mapTypeId);

  if (mapTypeId == google.maps.MapTypeId.ROADMAP) {
    document.getElementById("MTStd").style.backgroundColor = "#8BAD3C";
    document.getElementById("MTSat").style.backgroundColor = "#FFFFFF";

    document.getElementById("MTStd").style.color = "#FFFFFF";
    document.getElementById("MTSat").style.color = "#8BAD3C";
  } else {
    document.getElementById("MTStd").style.backgroundColor = "#FFFFFF";
    document.getElementById("MTSat").style.backgroundColor = "#8BAD3C";

    document.getElementById("MTStd").style.color = "#8BAD3C";
    document.getElementById("MTSat").style.color = "#FFFFFF";
  }
}

function numberWithCommas(x) {
  x = x.toString();
  var pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
  return x;
}

function geocodeAddress(address) {
  if (hosecalc_setting_boolDebugMode)
    console.log("geocodeAddress : " + address);
  geocoder.geocode({ address: address }, function (results, status) {
    if (status === "OK") {
      hosecalc_map.setCenter(results[0].geometry.location);
    } else {
      console.log(
        "Geocode was not successful for the following reason: " + status
      );
      document.getElementById("gobtn").style.backgroundColor = "red";
    }
  });
}

function ftn_buttonmouseover(id) {
  document.getElementById(id).style.backgroundColor = "#8BAD3C";
  document.getElementById(id).style.color = "#FFFFFF";
}

function ftn_buttonmouseout(id) {
  if (hosecalc_map) {
    if (
      hosecalc_map.getMapTypeId() == google.maps.MapTypeId.ROADMAP &&
      id == "MTSat"
    ) {
      document.getElementById(id).style.backgroundColor = "#FFFFFF";
      document.getElementById(id).style.color = "#8BAD3C";
    }

    if (
      hosecalc_map.getMapTypeId() == google.maps.MapTypeId.SATELLITE &&
      id == "MTStd"
    ) {
      document.getElementById(id).style.backgroundColor = "#FFFFFF";
      document.getElementById(id).style.color = "#8BAD3C";
    }
  }
}

function newhose() {
  if (hosecalc_setting_boolDebugMode) console.log("Call:newhose");

  //disable the old (current) polyline
  if (hosecalc_polyline) {
    hosecalc_polyline.setEditable(false);
  }

  //create new polyline
  hosecalc_polyline = new google.maps.Polyline({
    strokeColor: hosecalc_setting_lineColor,
    strokeOpacity: 1,
    strokeWeight: hosecalc_setting_lineWeight,
    geodesic: true,
    editable: true,
    clickable: false,
  });
  hosecalc_polyline.setMap(hosecalc_map);

  hosecalc_arr_polylines.push(hosecalc_polyline);

  //start new ployline;
  hosecalc_points = [];

  //reset undo
  pointsLastState = [];

  //disable undo button
  document.getElementById("btn_undo").disabled = true;
  document.getElementById("btn_undo").style.backgroundColor = "#d3d3d3";

  //disable new hose button
  document.getElementById("btn_newhose").disabled = true;
  document.getElementById("btn_newhose").style.backgroundColor = "#d3d3d3";

  //to prevent errors.
  google.maps.event.clearListeners(hosecalc_polyline, "click");
}
